export function _throw(error: Error): never {
  throw error;
}
